(function($){

    $(document).ready(function() {

        // Main menu animations
        $('#menuTrigger').on('click', function(){

            // close menu
            if($(this).hasClass('open')){

                $(this).text('Menu');
                $(this).removeClass('open');
                $('body').removeClass('disabled');
                $('html').removeClass('disabled');
                $('#siteLogo').hide().animate({top: '-300px'}, 50, function(){
                    $(this).show().delay(50).animate({top: '0px'});
                });
                $('#mainMenu').animate({top: '-300vh'}, 500, 'linear');
                $('#siteHeader').css('background-color', 'white');
                $('#mobileStickyCta').css('display', 'initial');

                if($(window.width < 1024)){
                    $('#mainMenu').css({'padding-top':'initial', 'margin-top':'initial'});
                }

                if($(window.width >= 1024)){
                    $('body').css({'position':'relative', 'width':'auto'});
                    $('#mainMenu').css('min-height', '100vh');
                }

            // open menu
            } else {

                let siteHeaderHeight = $('#siteHeader').height();

                $(this).text('Close');
                $(this).addClass('open');
                $('body').addClass('disabled');
                $('html').addClass('disabled');
                $('#siteLogo').hide().animate({top: '-300px'}, 50, function(){
                    $(this).show().delay(50).animate({top: '0px'});
                });
                $('#mainMenu').animate({top: '0px'}, 500, 'linear');
                setTimeout(siteHeaderBGColor, 400);
                $('#mobileStickyCta').css('display', 'none');

                function siteHeaderBGColor(){
                    $('#siteHeader').css('background-color', '#353C42')
                }

                if($(window.width < 1024)){
                    $('#mainMenu').css({'padding':'40px 0 80px', 'margin-top':siteHeaderHeight*1.5});
                }

                if($(window.width >= 1024)){
                    $('body').css({'position':'fixed', 'width':'100%'});
                    $('#mainMenu').css('min-height', '100vh');
                }

            }

        });


        // Go to top button
        $(window).scroll(function() {
            if ($(this).scrollTop() > 600){
                $('#goTop').addClass("active");
            } else {
                $('#goTop').removeClass("active");
            }
        });


        // Scroll on click
        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 1000);
        });


        // Animate form labels
        $('.wpcf7-form label input, .wpcf7-form label textarea, .wpcf7-form label select').focus(function(){
            $(this).closest('label').find('.inner-label').toggleClass('active');
        });

        $('.wpcf7-form label input, .wpcf7-form label textarea, .wpcf7-form label select').blur(function(){
            $(this).closest('label').find('.inner-label').toggleClass('active');
        });


        // Slick Sliders
        $('.blog-slider').slick({
            autoplay: false,
            speed: 700,
            dots: false,
            arrows: true,
            prevArrow:'<button type="button" class="slick-prev"><i class="fa-light fa-arrow-left"></i></button>',
            nextArrow:'<button type="button" class="slick-next"><i class="fa-light fa-arrow-right"></i></button>',
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3
                  }
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2
                  }
                },
                {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 1
                  }
                }
            ]
        });

        $('.inspiration-slider').slick({
            centerMode: true,
            autoplay: false,
            speed: 700,
            dots: false,
            arrows: true,
            prevArrow:'<button type="button" class="slick-prev"><i class="fa-light fa-arrow-left"></i></button>',
            nextArrow:'<button type="button" class="slick-next"><i class="fa-light fa-arrow-right"></i></button>',
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 576,
                  settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
        });

        $('.installer-photos').slick({
            autoplay: false,
            speed: 700,
            dots: false,
            arrows: true,
            prevArrow:'<button type="button" class="slick-prev"><i class="fa-light fa-arrow-left"></i></button>',
            nextArrow:'<button type="button" class="slick-next"><i class="fa-light fa-arrow-right"></i></button>',
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });

        $('.features-slider').slick({
            infinite: true,
            arrows: false,
            dots: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
                {
                  breakpoint: 1199,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                  }
                },
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  }
                },
                {
                  breakpoint: 575,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
                },
            ]
        });

        $('.related-products-slider').slick({
            infinite: true,
            arrows: false,
            dots: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                  breakpoint: 1199,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 575,
                  settings: {
                    slidesToShow: 1,
                  }
                },
            ]
        });
        

        // Remove empty paragraphs
        $('p:empty:not([role])').remove();


        // Remove p tags around images when using the WYSIWYG advanced custom field
        $('p > img').unwrap();


        $('[data-fancybox="gallery"]').fancybox({
            arrows: true,
            toolbar: true,
            transitionEffect: "fade",
            transitionDuration: 500,
            buttons: [
            "fullScreen",
            "close"
          ]
        });
        jQuery.fn.addBack = jQuery.fn.andSelf;

    });

})(jQuery);